// src/utils/adminUtils.js

const ADMIN_EMAILS = ["divyadasari2025@gmail.com"];

/**
 * Returns true if the given user is an admin.
 * Admins bypass all paywalls and have every challenge unlocked.
 */
export function isAdmin(user) {
  if (!user?.email) return false;
  return ADMIN_EMAILS.includes(user.email.toLowerCase());
}